export default "__VITE_ASSET__2eaffab7__"